module.exports = __webpack_public_path__ + "static/img/privacy-8-1.9c24039.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/privacy-8-1.png
// module id = 91ji
// module chunks = 1